import $ from "jquery";
window.dispatchEvent(new Event('resize'));

setTimeout(
    function(){
        window.dispatchEvent(new Event('resize'));
    }, 500
);

setTimeout(
    function(){
        window.dispatchEvent(new Event('resize'));
    }, 1000
);

setTimeout(
    function(){
        window.dispatchEvent(new Event('resize'));
    }, 2000
);

setTimeout(
    function(){
        window.dispatchEvent(new Event('resize'));
        // $('#hero').addClass('loaded');
    }, 3000
);

setTimeout(
    function(){
        window.dispatchEvent(new Event('resize'));
    }, 5000
);
